import { typescriptAsConst } from '@utils/typescriptAsConst';

export const routes = typescriptAsConst({
  internal: {
    auth_2fa_setup: () => '/accounts/2fa',
    auth_setPassword: () => '/accounts/set-password',

    // New "Mach2" UI, served under /v2/. This is only the mount prefix — the
    // TanStack Router in js/apps/mach2 owns all sub-routing beneath it.
    mach2_base: () => '/v2',

    client_overviewDashboard: () => '/cl-:clientSlug/dashboard',
    client_settingsUser: () => '/cl-:clientSlug/settings/users',
    client_archive: () => '/cl-:clientSlug/archive',
    client_publishedTests: () => '/cl-:clientSlug/testing',
    client_ipAllowLists: () => '/cl-:clientSlug/settings/ip_allowlists',
    client_dataValidationDashboard: () =>
      '/cl-:clientSlug/data-validation-dashboard',
    client_experimentTagManagement: () =>
      '/cl-:clientSlug/settings/experiment_tags',
    client_metricsExplorer: () => '/cl-:clientSlug/metrics-explorer',
    client_apiKeys: () => '/cl-:clientSlug/api/keys',
    client_apiDocumentation: () => '/cl-:clientSlug/api/documentation',
    site_dashboard: () => '/:accountSlug/dashboard',
    site_datasets: () => '/:accountSlug/datasets',
    site_editDomain: () => '/:accountSlug/edit',
    site_editDomainConfig: () => '/:accountSlug/config',
    site_failoverSettings: () => '/:accountSlug/failover/overview',
    site_failoverSettings_ensureAllCreated: () =>
      '/:accountSlug/failover/ensure_all_created',

    site_originSettings: () => '/:accountSlug/backends/list',
    site_originSettings_editConfig: () => '/:accountSlug/backends/edit/:id',
    site_originSettings_editOriginServers: () =>
      '/:accountSlug/backends/origin_servers/:id',
    site_originSettings_addOriginServers: () => '/:accountSlug/backends/add',

    site_section: () => '/:accountSlug/:sectionSlug',
    site_section_rule_add: () =>
      '/:accountSlug/:sectionSlug/rule/add/:ruleType/',
    site_section_rule_edit: () => '/:accountSlug/:sectionSlug/rule/:ruleId/',
    site_section_rule_adjuster_add: () =>
      '/:accountSlug/:sectionSlug/rule/:ruleId/adjuster/add/',
    site_section_rule_adjuster_edit: () =>
      '/:accountSlug/:sectionSlug/rule/:ruleId/adjuster/:adjusterId/edit/',
    site_section_variable_add: () => '/:accountSlug/:sectionSlug/variable/add',
    site_section_variable_edit: () => '/:accountSlug/:sectionSlug/variable/:id',
    site_section_variable_addBulk: () =>
      '/:accountSlug/:sectionSlug/variable/bulk_add',

    site_tests_dashboard: () => '/:accountSlug/testing',
    site_tests_results: () => '/:accountSlug/testing/results/:testId',
    site_tests_results_editDates: () =>
      '/:accountSlug/testing/results/:testId/edit_dates',
    site_tests_results_editName: () =>
      '/:accountSlug/testing/results/:testId/edit-name',
    site_tests_edit: () => '/:accountSlug/testing/in_section_test/test/:testId',
    site_tests_create_resp: () =>
      '/:accountSlug/testing/in_section_test/section/:sectionSlug',

    site_publish: () => '/:accountSlug/publish/live',
    site_publish_history: () => '/:accountSlug/publish/history',
    site_publish_compare: () => '/:accountSlug/publish/compare/',

    site_settings: () => '/:accountSlug/settings',
    site_settings_users: () => '/:accountSlug/settings/users',
    site_settings_editNotes: () => '/:accountSlug/settings/edit_notes',
    site_settings_site: () => '/:accountSlug/settings/edit',
    site_hodgepodge: () => '/:accountSlug/runway',
    site_settings_infrastuctureMonitoring: () => '/:accountSlug/stats',

    management_statusCake: () => '/management/statuscake',
    management_downloadRules: () => '/management/download_spec/:accountSlug',
    management_apiToken: () => '/management/api_token',
    management_apiKeys: () => '/management/api/keys',
    management_apiDocumentation: () => '/management/api/documentation',
    management_ipAllowLists: () => '/management/global_ip_allowlists',
    management_redisAdmin: () => '/management/kv-admin',
    management_redisKeysAdmin: () => '/management/kv-admin/:region/:db',
    management_redisKeysAdminInspect: () =>
      '/management/kv-admin/:region/:db/:site',
    management_analyticsConfig: () => '/management/analytics_config',
    management_benchmarking: () => '/management/benchmarking',
    management_compoundExperiment: () => '/management/compound_experiment',
    management_global_test_dashboard: () =>
      '/management/global_test_dashboard/',
    management_experiment_summary: () => '/management/experiment_summary/',
    management_batch_job_insights_dashboard: () =>
      '/management/batch_job_insights_dashboard/',
    management_test_result_sla_dashboard: () =>
      '/management/test_result_sla_dashboard/',
    management_ready_to_test_sla_dashboard: () =>
      '/management/ready_to_test_sla_dashboard/',
    management_saltshake_sla_dashboard: () =>
      '/management/saltshake_sla_dashboard/',
    management_vault: () => '/management/vault/',
    product_updates: () => '/product-updates',
  },
});
